import { render } from "./HealthcheckNotificationBar.vue?vue&type=template&id=2860de9c&scoped=true"
import script from "./HealthcheckNotificationBar.vue?vue&type=script&lang=js"
export * from "./HealthcheckNotificationBar.vue?vue&type=script&lang=js"

import "./HealthcheckNotificationBar.vue?vue&type=style&index=0&id=2860de9c&scoped=true&lang=css"

import exportComponent from "/home/cpaps/dev-sistema-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2860de9c"]])

export default __exports__